export default __webpack_public_path__ + "static/media/icon_time.3200ec41.svg";